(function () {
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function whenVisible(element, options, callback) {
    if (!('IntersectionObserver' in window)) {
      callback();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        window.requestAnimationFrame(callback);
      });
    }, options || { rootMargin: '30px 0px', threshold: 0 });

    observer.observe(element);
  }

  function animateElement(element, keyframes, options) {
    if (!element || typeof element.animate !== 'function') {
      if (element) element.style.opacity = '1';
      return null;
    }

    return element.animate(keyframes, options);
  }

  function splitLines(element) {
    if (!element || element.dataset.ibSplitComplete === 'true') return;
    var text = element.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;

    element.dataset.ibOriginalText = text;
    element.textContent = '';

    if (reducedMotion) {
      element.textContent = text;
      element.setAttribute('reveal-visibility', '');
      element.dataset.ibSplitComplete = 'true';
      return;
    }

    var words = text.split(' ');
    var probe = document.createElement('span');
    probe.style.display = 'inline';
    element.appendChild(probe);

    var lines = [];
    var lineWords = [];
    var lastTop = null;

    words.forEach(function (word) {
      var wordNode = document.createElement('span');
      wordNode.textContent = (probe.childNodes.length ? ' ' : '') + word;
      probe.appendChild(wordNode);
      var top = Math.round(wordNode.getBoundingClientRect().top);

      if (lastTop !== null && Math.abs(top - lastTop) > 2) {
        lines.push(lineWords.join(' '));
        lineWords = [word];
      } else {
        lineWords.push(word);
      }

      lastTop = top;
    });

    if (lineWords.length) lines.push(lineWords.join(' '));
    element.textContent = '';

    lines.forEach(function (line) {
      var span = document.createElement('span');
      span.style.display = 'block';
      span.style.opacity = '0';
      span.style.visibility = 'hidden';
      span.setAttribute('reveal', '');
      span.setAttribute('reveal-visibility', '');
      span.textContent = line;
      element.appendChild(span);
    });

    element.dataset.ibSplitComplete = 'true';
  }

  function revealLines(root, delayOffset) {
    var lines = root.querySelectorAll('[data-ib-split-lines] [reveal], ib-split-lines [reveal], .ib-split-lines [reveal]');
    Array.prototype.forEach.call(lines, function (line, index) {
      animateElement(line, [
        { opacity: 0, visibility: 'hidden', clipPath: 'inset(0 0 100% 0)', transform: reducedMotion ? 'translateY(0)' : 'translateY(100%)' },
        { opacity: 1, visibility: 'visible', clipPath: 'inset(0 0 0 0)', transform: 'translateY(0)' }
      ], {
        duration: 450,
        delay: reducedMotion ? 0 : (delayOffset || 0) + 100 * index,
        easing: 'cubic-bezier(0.5, 0.06, 0.01, 0.99)',
        fill: 'forwards'
      });
    });
  }

  function staggerItems(list) {
    var items = list.querySelectorAll('[data-ib-stagger-item], .grid__item');
    var distance = window.innerWidth >= 1000 ? 60 : 35;

    list.classList.add('became-visible');
    list.style.opacity = '1';

    Array.prototype.forEach.call(items, function (item, index) {
      item.style.opacity = '0';
      var delay = reducedMotion ? 0 : Math.max(0, (100 * index) - Math.min(3 * index * index, 100 * index));
      animateElement(item, [
        { opacity: 0, transform: reducedMotion ? 'translateY(0)' : 'translateY(' + distance + 'px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], {
        duration: 600,
        delay: delay,
        easing: 'ease',
        fill: 'forwards'
      });
    });
  }

  function initProductList(list) {
    if (list.dataset.ibProductListReady === 'true') return;
    list.dataset.ibProductListReady = 'true';
    list.style.opacity = '0';
    Array.prototype.forEach.call(list.querySelectorAll('[data-ib-stagger-item], .grid__item'), function (item) {
      item.style.opacity = '0';
    });
    var threshold = list.clientHeight > 0 ? Math.min(50 / list.clientHeight, 1) : 0;
    whenVisible(list, { threshold: threshold }, function () {
      staggerItems(list);
    });
  }

  function initHero(hero) {
    if (hero.dataset.ibHeroReady === 'true') return;
    hero.dataset.ibHeroReady = 'true';

    var splitTargets = hero.querySelectorAll('[data-ib-split-lines], ib-split-lines, .ib-split-lines');
    Array.prototype.forEach.call(splitTargets, splitLines);
    Array.prototype.forEach.call(hero.querySelectorAll('[reveal]'), function (node) {
      node.style.opacity = '0';
    });

    var slide = hero.querySelector('.ib-hero__slide.is-active, .ib-hero__slide');
    if (!slide) return;
    slide.style.visibility = 'hidden';
    slide.style.clipPath = reducedMotion ? 'inset(0 0 0 0)' : 'inset(0 0 0 100%)';

    animateElement(slide, [
      { visibility: 'hidden', clipPath: reducedMotion ? 'inset(0 0 0 0)' : 'inset(0 0 0 100%)' },
      { visibility: 'visible', clipPath: 'inset(0 0 0 0)' }
    ], {
      duration: 500,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      fill: 'forwards'
    });

    window.setTimeout(function () {
      revealLines(hero, 0);
      var revealables = Array.prototype.filter.call(hero.querySelectorAll('[reveal]'), function (node) {
        return !node.closest('[data-ib-split-lines], ib-split-lines, .ib-split-lines');
      });
      revealables.forEach(function (node, index) {
        animateElement(node, [
          { opacity: 0, clipPath: 'inset(0 0 100% 0)', transform: reducedMotion ? 'translateY(0)' : 'translateY(100%)' },
          { opacity: 1, clipPath: 'inset(0 0 0 0)', transform: 'translateY(0)' }
        ], {
          duration: 450,
          delay: reducedMotion ? 0 : 100 * index,
          easing: 'cubic-bezier(0.5, 0.06, 0.01, 0.99)',
          fill: 'forwards'
        });
      });
    }, reducedMotion ? 0 : 500);
  }

  function initReveal(host) {
    if (host.dataset.ibRevealReady === 'true') return;
    host.dataset.ibRevealReady = 'true';
    Array.prototype.forEach.call(host.querySelectorAll('[reveal]'), function (node) {
      node.style.opacity = '0';
      if (node.hasAttribute('reveal-visibility')) node.style.visibility = 'hidden';
    });
    whenVisible(host, { rootMargin: host.dataset.ibRevealRootMargin || '30px 0px', threshold: parseFloat(host.dataset.ibRevealThreshold || '0') }, function () {
      host.classList.add('became-visible');
      host.style.opacity = '1';
      revealLines(host, 0);
    });
  }

  function boot(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-ib-hero-motion]'), initHero);
    Array.prototype.forEach.call(root.querySelectorAll('[data-ib-product-list]'), initProductList);
    Array.prototype.forEach.call(root.querySelectorAll('[reveal-on-scroll]'), initReveal);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-ib-ajax-pagination] .pagination a');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!window.fetch || !window.DOMParser) return;

    event.preventDefault();

    fetch(link.href, { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('#Collection');
        var current = document.querySelector('#Collection');
        if (!next || !current) {
          window.location.href = link.href;
          return;
        }

        current.innerHTML = next.innerHTML;
        window.history.pushState({}, '', link.href);
        boot(current);
        current.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      })
      .catch(function () {
        window.location.href = link.href;
      });
  });

  window.IvoryBloomMotion = {
    boot: boot,
    staggerItems: staggerItems
  };
})();
